module.exports = __webpack_public_path__ + "static/media/appwiz_1500.c6084a95.ico";